import React from "react";
import img1 from "../../assets/images/png_pic/seff-1.png";
import img4 from "../../assets/images/png_pic/grid1.png";
import img3 from "../../assets/images/png_pic/errect-1.png";
import img2 from "../../assets/images/png_pic/self-1.png";
import img5 from "../../assets/images/png_pic/trolley-3.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section>
      <section className="relative ">
        <div className=" mx-auto flex h-auto w-full max-w-[100vw] overflow-hidden transition-all">
          <div className="relative z-10 mx-auto h-full min-w-[100vw] overflow-hidden  bg-gray-50">
            <div className="container mx-auto py-5 md:py-10 lg:py-12 " data-aos="zoom-out-down">
              <div className="flex flex-wrap items-center">

                <div className="w-full px-4 lg:w-1/2">
                  <div className="mt-5 max-w-[570px] md:mt-8 lg:mt-10">
                    <span className="mb-[14px] block md:text-lg font-semibold text-[#E66A22]">
                      Strong, Safe and Reliable
                    </span>
                    <h2 className="mb-[18px] capitalize text-2xl font-bold leading-tight xl:text-4xl sm:text-3xl md:text-3xl">
                      Welcome to Yogesh Aluminium Ladder
                    </h2>
                    <p className="mb-9 text-sm md:text-base">
                      Discover the our best aluminium ladders for all your
                      needs.
                    </p>
                    <Link to={'/product'} className='hidden lg:block'>
                    <button
                      
                      className="inline-flex items-center justify-center rounded-full bg-[#182e55] px-5 md:px-7 py-[13px] text-center text-sm md:text-base font-medium text-white hover:bg-[#234279]"
                    >
                      Shop Now
                    </button>
                    </Link>
                  </div>
                </div>

                {/* image show */}
                <div className="w-full px-4 lg:w-1/2">
                  <div className=" text-center">
                    <Swiper
                      modules={[Autoplay, Pagination]}
                      autoplay={{
                        delay: 3000, // Time delay between slides (in ms)
                        disableOnInteraction: false, // Keeps autoplay active after user interaction
                      }}
                      // pagination={{ clickable: true }}
                      loop={true} // Makes the slider loop infinitely
                      className="h-full "
                    >
                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img1}
                            className="h-[300px] md:h-[500px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img2}
                            className="h-[300px] md:h-[500px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img3}
                            className="h-[300px] md:h-[500px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>

                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img4}
                            className="h-[300px] md:h-[500px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>

                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img5}
                            className="h-[300px] md:h-[500px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute right-0 top-0 -z-10">
              <svg
                width="620"
                height="560"
                viewBox="0 0 620 560"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 560L256.5 0H620V560H0Z"
                  fill="url(#paint0_linear_2066_370)"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_2066_370"
                    x1="100.001"
                    y1="280"
                    x2="535.002"
                    y2="280"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#3056D3" stop-opacity="0.08"></stop>
                    <stop
                      offset="1"
                      stop-color="#3056D3"
                      stop-opacity="0"
                    ></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="absolute right-0 top-0 -z-10">
              <svg
                width="536"
                height="560"
                viewBox="0 0 536 560"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.998535 560L257.499 0H535.999V560H0.998535Z"
                  fill="url(#paint0_linear_2066_368)"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_2066_368"
                    x1="101"
                    y1="280"
                    x2="536"
                    y2="280"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#3056D3" stop-opacity="0.08"></stop>
                    <stop
                      offset="1"
                      stop-color="#3056D3"
                      stop-opacity="0"
                    ></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default HeroSection;
